import { useMainRoutes } from './hooks';

import type { UserRole } from 'applications/GSP/shared/types';
import type { RouteObject } from 'shared/types';

export const useRoutes = (role: UserRole): RouteObject[] => {
  const mainRoutes = useMainRoutes(role);

  return mainRoutes;
};
